import { InvoiceStatus } from 'entities/Invoice';
import { UserAccountType } from 'entities/User';
import { TableFilterType } from 'features/TableFilter';
import { getFilterServerFormatDate } from 'shared/utils/helpers/getDateFormat';

interface InvoiceListFilters {
  warehouseId?: string;
  isActive?: boolean;
  invoiceTypes?: string;
  invoiceAmount?: number;
  invoicingDateFrom?: string;
  invoicingDateTo?: string;
  dueDateFrom?: string;
  dueDateTo?: string;
  creationDateFrom?: string;
  creationDateTo?: string;
  status?: InvoiceStatus;
  invoiceNumberFrom?: string;
  invoiceNumberTo?: string;
  isApplicable?: boolean;
  statusRefDate?: string;
  contractClosed?: boolean;
  paymentMethods?: string;
  accountType?: UserAccountType;
  userId?: string;
  discountKey?: string;
  paymentDateFrom?: string;
  paymentDateTo?: string;
}

export const transformInvoicesListFilters = ({
  selectedWarehouses,
  invoiceTypes,
  isActive,
  invoiceAmount,
  invoicingDateFrom,
  invoicingDateTo,
  creationDateFrom,
  creationDateTo,
  dueDateFrom,
  dueDateTo,
  status,
  invoiceNumberFrom,
  invoiceNumberTo,
  isApplicable,
  statusRefDate,
  contractStatus,
  paymentMethods,
  accountType,
  userIds,
  discountKey,
  paymentDateFrom,
  paymentDateTo,
}: TableFilterType): InvoiceListFilters => {
  return {
    warehouseId: selectedWarehouses?.value || undefined,
    isActive: isActive?.value === undefined ? undefined : isActive?.value === 'active',
    invoiceTypes: invoiceTypes?.value || undefined,
    isApplicable: isApplicable?.value === undefined ? undefined : isApplicable?.value === 'applicable',
    invoiceAmount: invoiceAmount?.value || undefined,
    invoicingDateFrom: getFilterServerFormatDate(invoicingDateFrom?.value),
    invoicingDateTo: getFilterServerFormatDate(invoicingDateTo?.value),
    creationDateFrom: getFilterServerFormatDate(creationDateFrom?.value),
    creationDateTo: getFilterServerFormatDate(creationDateTo?.value),
    dueDateFrom: getFilterServerFormatDate(dueDateFrom?.value),
    dueDateTo: getFilterServerFormatDate(dueDateTo?.value),
    status: status?.value || undefined,
    invoiceNumberFrom: invoiceNumberFrom?.value || undefined,
    invoiceNumberTo: invoiceNumberTo?.value || undefined,
    statusRefDate: getFilterServerFormatDate(statusRefDate?.value),
    contractClosed: contractStatus?.value === undefined ? undefined : contractStatus?.value === 'closed',
    paymentMethods: paymentMethods?.value || undefined,
    accountType: accountType?.value || undefined,
    userId: userIds?.value || undefined,
    discountKey: discountKey?.value || undefined,
    paymentDateFrom: getFilterServerFormatDate(paymentDateFrom?.value),
    paymentDateTo: getFilterServerFormatDate(paymentDateTo?.value),
  };
};
